import React from 'react'
import { useNavigate } from 'react-router-dom'
import { HighlightOff } from '@mui/icons-material'
import LoadingSpinner from '../../../LoadingSpinner'
import { READ_ONLY_USER_MESSAGE, useReadOnlyUser } from './useReadOnlyUser'
import { AlertModal } from '../../../common/AlertModal'

type ReadOnlyUserGuardProps = {
	children: React.ReactNode
}

const ReadOnlyUserGuard: React.FC<ReadOnlyUserGuardProps> = ({ children }) => {
	const navigate = useNavigate()
	const { isLoading, isReadOnly } = useReadOnlyUser()

	if (isLoading) {
		return <LoadingSpinner />
	}

	if (isReadOnly) {
		return (
			<AlertModal
				isOpen
				icon={<HighlightOff color="error" sx={{ fontSize: 50 }} />}
				title="Oops!"
				text={READ_ONLY_USER_MESSAGE}
				buttonSx={{ color: 'white', borderRadius: '5px !important' }}
				buttonProps={{ variant: 'contained', color: 'error', size: 'medium' }}
				onClose={() => navigate('/dashboard')}
			/>
		)
	}

	return <>{children}</>
}

export default ReadOnlyUserGuard
